<template>
  <div class="qr-wrapper">
    <div class="bg-orb bg-orb-1"></div>
    <div class="bg-orb bg-orb-2"></div>

    <div class="qr-center">
      <!-- Header -->
      <div class="qr-header">
        <router-link to="/admin" class="back-btn glass-btn">
          <v-icon dark size="16">mdi-arrow-left</v-icon>
          Painel Admin
        </router-link>
        <router-link to="/" class="back-btn glass-btn">
          <v-icon dark size="16">mdi-home-outline</v-icon>
        </router-link>
      </div>

      <!-- Card principal -->
      <div class="qr-card glass-strong">
        <div class="qr-card-header">
          <img src="@/assets/logo-white.png" class="qr-logo" />
          <div>
            <h2 class="qr-title">Gerador de QR Code</h2>
            <p class="qr-subtitle">Identificação digital do pet</p>
          </div>
        </div>

        <div class="qr-body">
          <!-- Lado esquerdo: input -->
          <div class="qr-controls">
            <div class="form-group">
              <label class="ctrl-label">Código do Microchip</label>
              <input
                v-model="qrCodeValue"
                class="glass-input qr-input"
                placeholder="Ex: 900123456789"
                @input="qrCodeValue = qrCodeValue.toUpperCase()"
              />
            </div>

            <div class="url-preview-box">
              <span class="ctrl-label">URL gerada</span>
              <code class="url-code">{{ finalUrl }}</code>
            </div>

            <button class="btn-primary dl-btn" @click="downloadQR">
              <v-icon dark size="17">mdi-download</v-icon>
              Baixar QR Code
            </button>

            <p class="qr-hint">
              O QR Code direciona para a página pública do pet. Imprima e afixe na coleira ou tag.
            </p>
          </div>

          <!-- Lado direito: preview QR -->
          <div class="qr-preview-col">
            <div class="qr-canvas-container" ref="qrWrapper">
              <qrcode-vue
                :value="finalUrl"
                :size="220"
                level="H"
                render-as="canvas"
                foreground="#0f4c4a"
              ></qrcode-vue>
              <div class="qr-logo-overlay">
                <img src="@/assets/logo.png" alt="Logo" />
              </div>
            </div>
            <p class="qr-scan-hint">Aponte a câmera para escanear</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import logo from "@/assets/logo.png";

export default {
  name: "GeradorQr",
  components: { QrcodeVue },

  data() {
    return {
      qrCodeValue: "",
      baseUrl: "https://finotrato.com.br/consultar-pet/",
    };
  },

  computed: {
    finalUrl() {
      return this.baseUrl + (this.qrCodeValue || "PENDENTE");
    },
  },

  methods: {
    async downloadQR() {
      const canvas = this.$refs.qrWrapper && this.$refs.qrWrapper.querySelector("canvas");
      if (!canvas) return;

      const dl = document.createElement("canvas");
      dl.width = canvas.width;
      dl.height = canvas.height;
      const ctx = dl.getContext("2d");
      ctx.drawImage(canvas, 0, 0);

      const logoImg = new Image();
      logoImg.src = logo;
      await new Promise((r) => { logoImg.onload = r; });

      const size = canvas.width * 0.16;
      const pos = (canvas.width - size) / 2;
      ctx.fillStyle = "white";
      ctx.beginPath();
      ctx.arc(canvas.width / 2, canvas.height / 2, size / 2 + 7, 0, Math.PI * 2);
      ctx.fill();
      ctx.drawImage(logoImg, pos, pos, size, size);

      const link = document.createElement("a");
      link.download = `qr-fino-trato-${this.qrCodeValue || "pet"}.png`;
      link.href = dl.toDataURL("image/png");
      link.click();
    },
  },
};
</script>

<style scoped>
.qr-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 24px;
}

.qr-center {
  width: 100%;
  max-width: 740px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  z-index: 1;
}

.qr-header {
  display: flex;
  gap: 10px;
}

.back-btn {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.75) !important;
  border-radius: 10px;
  font-size: 0.82rem;
}

.back-btn:hover {
  color: #fff !important;
}

/* Card */
.qr-card {
  border-radius: 28px;
  padding: 36px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.qr-card-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.qr-logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
  filter: drop-shadow(0 2px 8px rgba(44, 183, 177, 0.4));
}

.qr-title {
  color: #fff;
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0;
}

.qr-subtitle {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.82rem;
  margin: 4px 0 0;
}

.qr-body {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 36px;
  align-items: center;
}

/* Controls */
.qr-controls {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.ctrl-label {
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.qr-input {
  font-size: 1rem !important;
  padding: 13px 16px !important;
  border-radius: 12px !important;
  letter-spacing: 1px;
}

.url-preview-box {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.url-code {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: var(--primary-light, #5fd1cb);
  font-size: 0.78rem;
  padding: 10px 14px;
  word-break: break-all;
  font-family: monospace;
  line-height: 1.5;
}

.dl-btn {
  border-radius: 12px;
  padding: 13px 24px;
  font-size: 0.88rem;
  letter-spacing: 0.5px;
  justify-content: center;
}

.qr-hint {
  color: rgba(255, 255, 255, 0.38);
  font-size: 0.75rem;
  line-height: 1.6;
  margin: 0;
}

/* Preview col */
.qr-preview-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.qr-canvas-container {
  position: relative;
  padding: 16px;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
  display: inline-block;
}

.qr-logo-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 44px;
  height: 44px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  pointer-events: none;
}

.qr-logo-overlay img {
  width: 100%;
  height: auto;
}

.qr-scan-hint {
  color: rgba(255, 255, 255, 0.35);
  font-size: 0.72rem;
  margin: 0;
}
</style>
